import { render } from "./Avatar.vue?vue&type=template&id=04acd1e0&ts=true"
import script from "./Avatar.vue?vue&type=script&lang=ts"
export * from "./Avatar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/start/Avatar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04acd1e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04acd1e0', __exports__)) {
    api.reload('04acd1e0', __exports__)
  }
  
  module.hot.accept("./Avatar.vue?vue&type=template&id=04acd1e0&ts=true", () => {
    api.rerender('04acd1e0', render)
  })

}


export default __exports__